import React from 'react';
import LoadingIndicator from '../../components/LoadingIndicator';
import FixedFullscreenDiv from '../FixedFullscreenDiv';
import VerticalCenterContent from '../../styledhtml/VerticalCenterContent';
import Constants from '../../submodules/logictry_config/constants';
export default function LoadingFullscreen() {
  if (Constants.isWidget) return <VerticalCenterContent alignTop><LoadingIndicator /></VerticalCenterContent>;
  return <FixedFullscreenDiv style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><LoadingIndicator /></FixedFullscreenDiv>;
}
